import { render } from "./HistoryInfo.vue?vue&type=template&id=23c770db&scoped=true"
import script from "./HistoryInfo.vue?vue&type=script&lang=js"
export * from "./HistoryInfo.vue?vue&type=script&lang=js"

import "./HistoryInfo.vue?vue&type=style&index=0&id=23c770db&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c770db"]])

export default __exports__